import React from 'react';
import { isNewUIEnabled } from 'hooks/useNewUI';
import CreateCategoryNew from './CreateCategoryNew';
import CreateCategoryClassic from './CreateCategoryClassic';

// The MUI-v5 dark-accent restyle of the create/edit category modal ships only
// to allow-listed new-UI users. Classic (production) users keep the legacy
// modal look and feel.
const CreateCategoryPage = (props) => (isNewUIEnabled()
  ? <CreateCategoryNew {...props} />
  : <CreateCategoryClassic {...props} />);

export default CreateCategoryPage;
